import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};
internals.addVendor = (vendor) => {
  vendor = Object.assign({}, vendor);
  const promises = [];
  return http
    .post("/vendor/create", {
      cityId:vendor.cityId,
      vdName: vendor.vdName,
      vdEmail: vendor.vdEmail,
      vdContact: vendor.vdContact,
    })
    .then((result) => {
      vendor = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("VendorService.createVendor-error:\n", error);
      throw error;
    });
};

internals.updateVendor = (_id, vendor) => {
  return http
    .put(`/vendor/update`, {
      _id: vendor._id,
      cityId:vendor.cityId,
      vdName: vendor.vdName,
      vdEmail: vendor.vdEmail,
      vdContact: vendor.vdContact,
    })
    .then((result) => {
      vendor = result.data;
      return vendor;
    })
    .catch((error) => {
      console.error("VendorUpdate.update-error:\n", error);
      throw error;
    });
};

internals.updateVendorStatus = (vendor) => {
  const promises = [];
  return http
    .put("/vendor/update", {
      cityId:vendor.cityId,
      vdName: vendor.vdName,
      // vdEmail: vendor.vdEmail,
      vdContact: vendor.vdContact,
      status: vendor.status,
      _id: vendor._id,
    })
    .then((result) => {
      vendor = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("authService.inviteUser-error:\n", error);
      throw error;
    });
};

internals.getById = (_id) => {
  return http
    .get(`/vendor/ById?_id=${_id}`)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("wasteRecycle.Get-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/vendor.service.js